import styled from "styled-components";

export const ErrorMessage = styled.div`
  margin-top: 0.5rem;
`;

export const ErrorList = styled.ol`
  margin: 0;
  padding: 0 0 1rem 0;

  li + li {
    margin-top: 0.25rem;
  }
`;

export const ErrorListItem = styled.li`
  list-style-position: inside;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
